import React, { useEffect, useState } from "react";
import { notificationImages, post } from "../../config/imagesLink";
import {
  Table,
  Card,
  UncontrolledDropdown,
} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import axios from "../../API/axios";
import moment from "moment";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import DescriptionIcon from '@mui/icons-material/Description';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// import { Link } from 'react-router-dom'
import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import Flatpickr from "react-flatpickr";
import ArrowForwardSharpIcon from "@mui/icons-material/ArrowForwardSharp";
import { Tooltip } from "@mui/material";
import { ListRowSkeleton } from "@skeleton";
import { useTranslation } from "react-i18next";
const JobNotification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();


  const [acceptNotification, setacceptNotification] = useState(false);
  const handleRemoveCertificateClose = () => {
    setacceptNotification(false);
  };

  const [showEducationDelete, setShowEducationDelete] = useState(false);

  const handleRemoveEducationClose = () => {
    setShowEducationDelete(false);
  };
  const sessionId = localStorage.getItem("sessionId");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  //************************Job Application Start  ************************//
  const [loading, setLoading] = useState(false);
  const [errorImage, setErrorImage] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [jobApplication, setJobApplication] = useState([]);
  const [jobApplicationid, setJobApplicationid] = useState("");
  const [isDeletedJobOffer, setIsDeletedJobOffer] = useState(false);
  const language = localStorage.getItem("Lang");

  const [nextBatchLoading, setNextBatchLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);

  const getJobApplicationl = (page) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 12,
    };

    setLoading(true);
    axios
      .post(`JobApplication/GetAllJobApplications`, data)
      .then((response) => {
        setLoading(false);

        if (response.status === 204 || response.status === 404) {
          setErrorImage(true);
        } else {
          setTotalPages(response.data.responseData.paging.totalPages);
          const newPosts = response.data.responseData.jobApplications;
          // console.log('jhgdsjhgfsd', newPosts);
          setJobApplication((prev) => {
            const postSet = new Set(prev.map((post) => post.jbApplctnId));
            const uniqueNewPosts = newPosts.filter(
              (post) => !postSet.has(post.jbApplctnId)
            );
            return [...prev, ...uniqueNewPosts];
          });
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorImage(true);
        setLoading(false);
      });
  };
  const getJobApplication = async (page) => {
    setLoading(true);

    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: page,
      pageSize: 10,
      langKey: language === "en" ? "" : language,
    };
    try {
      setNextBatchLoading(true);
      const resData = await axios.post("JobApplication/GetAllJobApplications", data);

      setLoading(false);
      setTotalPages(resData?.data?.responseData?.paging?.totalPages);
      const newPosts = resData?.data.responseData.jobApplications || 0;
      console.log("newPostsssssssssss", newPosts);
      if (resData.status === 204 || resData.status === 404) {
        setErrorImage(true);
        setLoading(false);
        setHasMoreData(false);

      } else {
        setJobApplication((prev) => {
          const postSet = new Set(prev.map((post) => post.jbApplctnId));
          const uniqueNewPosts = newPosts.filter(
            (post) => !postSet.has(post.jbApplctnId)
          );
          return [...prev, ...uniqueNewPosts];
        });
      }

      if (page >= resData.data.responseData.paging.totalPages) {
        setHasMoreData(false);
      }
      setNextBatchLoading(false);

    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 404) {
        setErrorImage(true);
      } else {
        console.error(error);
      }
      setNextBatchLoading(false);
    }
  };

  useEffect(() => {
    if (hasMoreData && totalPages >= page) {
      getJobApplication(page);
    }
  }, [page]);

  // const handleInfiniteScroll = async () => {
  //   try {
  //     if (
  //       window.innerHeight + document.documentElement.scrollTop + 1 >=
  //       document.documentElement.scrollHeight
  //     ) {
  //       setLoading(true);
  //       setPage((prev) => prev + 1);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const handleInfiniteScroll = async () => {

    if (nextBatchLoading || !hasMoreData) return;
    if (
      window.innerHeight + document.documentElement.scrollTop + 1 >=
      document.documentElement.scrollHeight
    ) {
      setNextBatchLoading(true); // lock until API finishes
      setPage((prev) => prev + 1);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, [nextBatchLoading, hasMoreData]);

  //************************Job Application End  ************************//

  //************************Accept Job Start  ************************//
  const AcceptJob = (jobId) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      jbApplctnId: jobId,
      hiringStatus: "Shortlisted",
      remark: null,
    };
    axios
      .post(`JobApplication/UpdateHiringStatus`, data)
      .then((response) => {
        // console.log("getJobApplication", response.data.responseData);
        const res = response.data.responseData;

        setToastMessage(response.data.message);
        setShowToast(true);
        getJobApplication(page);
        setJobApplication((prevJobs) =>
          prevJobs.map((job) =>
            job.jbApplctnId === jobId
              ? { ...job, hiringStatus: 4, hiringStatusName: '"Shortlisted"' } // Update hiringStatus
              : job
          )
        );
      })
      .catch((e) => {
        console.log(e);
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
        }
      });
  };
  //************************Accept Job End  ************************//

  //************************Reject Job Start  ************************//
  const RejectJob = (jobId) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      jbApplctnId: jobApplicationid,
      hiringStatus: "Declined",
      remark: null,
    };
    axios
      .post(`JobApplication/UpdateHiringStatus`, data)
      .then((response) => {
        // console.log("getJobApplication", response.data.responseData);
        const res = response.data.responseData;
        setToastMessage(response.data.message);
        setShowToast(true);

        getJobApplication(page);

        setJobApplication((prevJobs) =>
          prevJobs.filter((job) => job.jbApplctnId !== jobApplicationid)
        );
      })
      .catch((e) => {
        console.log(e);
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
        }
      });
  };
  //************************Reject Job End  ************************//

  useEffect(() => {
    if (acceptNotification || showEducationDelete) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [acceptNotification, showEducationDelete]);
 
  const InterviewPlaceType = [ 
    { value: '1', label: t("SearchJob.OnSite") },
    { value: '2', label: t("SearchJob.Remotely") },
    { value: '3', label: t("SignIn.others") },
  ];
  const [startDate, setStartDate] = useState(null);
  const [interviewPT, setInterviewPT] = useState("");
  const [placeDetail, setPlaceDetail] = useState("");
  const [currentJobId, setCurrentJobId] = useState(null);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [remark, setRemark] = useState("");
  const handleScheduleModal = (jobId = null) => {
    setCurrentJobId(jobId);
    setScheduleModal(!scheduleModal);
  };

  const handleSubmitSechdule = () => {
    if (currentJobId) {
      Schedule(currentJobId);
    }
  };
  const Schedule = (jobId) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      jbApplctnId: jobId,
      scheduleTime:
        startDate === "" ? "" : moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
      placeType: interviewPT,
      placeDetails: placeDetail,
      remark: remark,
      langKey: language === "en" ? "" : language,
    };
    console.log(data);
    if (startDate === "" || interviewPT === "") {
      setWarningToastMessage(t("modals.Please fill all the required fields"));
      setShowWarningToast(true);
    } else {
      axios
        .post(`JobApplication/ScheduleInterview`, data)
        .then((response) => {
          const res = response.data.responseData;
          setToastMessage(response.data.message);
          setShowToast(true);
          setRemark("");
          setStartDate(null);
          setInterviewPT("");
          setPlaceDetail("");
          setScheduleModal(false);
          // setJobApplication((prevJobs) =>
          //   prevJobs.map((job) => job.jbApplctnId === jobId
          //     ? { ...job, hiringStatus: 4, hiringStatusName: 'Scheduled' } // Update hiringStatus
          //     : job
          //   )
          // );
          setJobApplication((prevJobs) =>
            prevJobs.filter((job) => job.jbApplctnId !== jobId)
          );
        })
        .catch((e) => {
          console.log(e);
          if (e.response && e.response.status === 404) {
            setWarningToastMessage(e.response.data.message);
            setShowWarningToast(true);
          } else {
            setErrorToastMessage(e.response.data.message);
            setShowErrorToast(true);
          }
        });
    }
  };
  const preventYearScroll = (datePickerInstance) => {
    const yearElement = datePickerInstance.currentYearElement;
    if (yearElement) {
      yearElement.addEventListener("wheel", (e) => {
        e.preventDefault(); // Stops mouse scroll
      });
    }
  };

  const [isRemoveJobOfferModal, setIsRemoveJobOfferModal] = useState(false)
  const handleRemoveOfferedJobs = async () => {
    setIsRemoveJobOfferModal(false);
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      jbApplctnId: jobApplicationid,
    };
    axios
      .post(`JobAction/RemoveJobOffer`, data)
      .then((response) => {
        // console.log("getJobApplication", response.data.responseData);
        const res = response.data.responseData;
        setToastMessage(response.data.message);
        setShowToast(true);

        getJobApplication(page);

        setJobApplication((prevJobs) =>
          prevJobs.filter((job) => job.jbApplctnId !== jobApplicationid)
        );
      })
      .catch((e) => {
        console.log(e);
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
        }
      });
  };
  const handleReStoreJobOffer = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      jbApplctnId: jobApplicationid,
    };
    axios
      .post(`JobAction/RestoreDeletedJobApplication`, data)
      .then((response) => {
        // console.log("getJobApplication", response.data.responseData);
        const res = response.data.responseData;
        setToastMessage(response.data.message);
        setShowToast(true);

        getJobApplication(page);

        setJobApplication((prevJobs) =>
          prevJobs.filter((job) => job.jbApplctnId !== jobApplicationid)
        );
      })
      .catch((e) => {
        console.log(e);
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
        }
      });
  };


  // change page scroll top

  useEffect(() => {
    if (location.pathname === "/JobApplications") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname]);

  const cleanShortDescription = (htmlString) => {
    return htmlString
      ?.replace(/<h3>/gi, "<div>")
      ?.replace(/<\/h3>/gi, "</div>")
      ?.replace(/<strong>/gi, "")
      ?.replace(/<\/strong>/gi, "");
  };

  return (
    <>
      <div className="jobHeader p-4 mt-1 d-flex justify-content-between">
        <div className="friendsHeaderText mt-1">
          <h1 className=""> {t("Job Application.Job Applications")} </h1>
        </div>
        <a
          className="linkSearch f-14 d-flex align-items-center  pointer"
          onClick={() => navigate("/Interview")}
        >
          {t("Job Application.Interviews")}
          <ArrowForwardSharpIcon className="material-symbols-sharp" />
        </a>
      </div>


      {loading ? (

        <ListRowSkeleton count={5} rowHeight={80} />
      ) : errorImage || jobApplication?.length === 0 ? (
        <>
          <div className="mt-2 text-center">

            <img src={post.errorSmall} alt="404 Not Found" width={300} />

          </div>
        </>
      ) : (
        <>
          <div className="job-notification-main-container Newjob-notification-main-container">
            <div className="job-notification-card">
              <Card className="transaction-table vh-100">
                <Table responsive className="notification-table notification-tab-mobview table-bordered">
                  <thead style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                    <tr className="f-12 f-600 table-header">
                      <th> {t("Job Application.Candidates Name")}</th>
                      <th>  {t("Job Application.Job Description")}</th>
                      <th> {t("Job Application.Apply On")}</th>
                      <th> {t("Job Application.Action")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {jobApplication &&
                      jobApplication?.map((item, index) => {
                        return (
                          <tr>
                            <td className="row-gap HuzJobNotification">
                              <div className="card-image-text d-flex align-items-center">
                                <div className="card-image me-1">
                                  <img
                                    src={item?.userProfilePic}
                                    alt=""
                                    srcset=""
                                    width={40}
                                    height={40}
                                    style={{ borderRadius: "50%" }}
                                  />
                                </div>
                                <div>
                                  <UncontrolledDropdown
                                    tag="li"
                                    className="nav-item user-detail"
                                  >
                                    <Link
                                      to={`/User/${item.userUid}`}
                                      tag="a"
                                      // onClick={`/User/${item.userUid}`}
                                      target="blank"
                                    // onClick={(e) => e.preventDefault()}
                                    >
                                      <div className="card-text f-14 f-500 d-flex">
                                        {item?.userName}
                                      </div>
                                    </Link>
                                  </UncontrolledDropdown>
                                </div>
                              </div>
                            </td>
                            <td className="w-20">
                              {" "}
                              <div className="job-desc-text f-14 f-400 ">
                                <Link
                                  className="job-desc-text "
                                  to={`/JobDetail/${item.jobId}`}
                                  target="_blank"
                                >
                                  {item?.jobTitle}
                                  <small className="d-block f-10">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: cleanShortDescription(
                                          item?.shortDescription?.length > 100
                                            ? item?.shortDescription?.slice(0, 100) + "..."
                                            : item?.shortDescription
                                        ),
                                      }}
                                      style={{ fontSize: "12px", lineHeight: "1.5" }}
                                    />
                                    {/* {item?.shortDescription} */}
                                  </small>
                                </Link>
                                {/* {item?.jobTitle}
                                        <small className="d-block f-10">{item?.shortDescription}</small> */}
                              </div>
                            </td>
                            <td>
                              <div className="apply-on-text f-14 f-400">
                                {/* Jun 21, 2019 */}
                                {moment(item.appliedTime).format("ll")}
                              </div>
                            </td>
                            <td>
                              {" "}
                              <div className="actions-cont">
                                <ul className="d-flex mb-0 p-0">
                                  <li className="me-2 Icon">
                                    <Link
                                      to={`/Resume/${item.userUid}`}
                                      target="_blank"
                                    >
                                      <Tooltip title={t("Job Application.View Resume")} arrow>
                                        <DescriptionIcon />
                                      </Tooltip>
                                      {/* <img
                                                  src={notificationImages.notifyImg4}
                                                  alt=""
                                                  srcset=""
                                                /> */}
                                    </Link>
                                  </li>

                                  <li
                                    className="pointer me-2 "
                                    onClick={() => {
                                      setShowEducationDelete(
                                        !showEducationDelete
                                      );
                                      setJobApplicationid(item?.jbApplctnId);
                                      // RejectJob(item?.jbApplctnId)
                                    }}
                                  >
                                    <Tooltip title={t("Job Application.Reject")} arrow>
                                      <CancelIcon style={{ color: '#d60d0d' }} />
                                    </Tooltip>
                                    {/* <img
                                                src={notificationImages.notifyImg2}
                                                alt=""
                                                srcset=""
                                              /> */}
                                  </li>

                                  {item?.hiringStatus === 4 ? (
                                    // <ApplicationStatus item={item} />
                                    <li
                                      className="me-2 pointer Icon"
                                      onClick={() => {
                                        handleScheduleModal(item?.jbApplctnId);
                                      }}
                                    >
                                      <Tooltip title={t("Job Application.Schedule")} arrow>
                                        <CalendarMonthSharpIcon />
                                      </Tooltip>
                                    </li>
                                  ) : (
                                    <li
                                      className="me-2 pointer"
                                      onClick={() => {
                                        // setacceptNotification(!acceptNotification);
                                        // setJobApplicationid(item?.jbApplctnId)
                                        AcceptJob(item?.jbApplctnId);
                                      }}
                                    >
                                      <Tooltip title={t("Job Application.Accept")} arrow>
                                        <CheckCircleIcon style={{ color: 'green' }} />
                                      </Tooltip>
                                      {/* <img
                                                  src={notificationImages.notifyImg1}
                                                  alt=""
                                                  srcset=""
                                                /> */}
                                    </li>
                                  )}



                                  {!isDeletedJobOffer ? (
                                    <li
                                      className="pointer"
                                      onClick={() => {
                                        setJobApplicationid(item?.jbApplctnId);
                                        setIsRemoveJobOfferModal(true)
                                      }}
                                    >
                                      <Tooltip title={t("Job Application.Delete")} arrow>
                                        <DeleteIcon style={{ color: '#d60d0d' }} />
                                        {/* <img
                                                  style={{ width: 20, height: 20 }}
                                                  src={notificationImages.deleteIcon}
                                                  alt=""
                                                  srcset=""
                                                /> */}
                                      </Tooltip>
                                    </li>
                                  ) : (
                                    <li
                                      className="pointer"
                                      onClick={() => {
                                        setJobApplicationid(item?.jbApplctnId);
                                        handleReStoreJobOffer();
                                      }}
                                    >
                                      <img
                                        // src={notificationImages.restoreIcon}
                                        style={{ width: 20, height: 20 }}
                                        src={notificationImages.reStoreIcon}
                                        alt=""
                                        srcset=""
                                      />
                                    </li>
                                  )}
                                </ul>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </Card>
            </div>
          </div>
        </>
      )}
      {!hasMoreData || jobApplication.length > 12 ? (
        <p className="text-center AddBottomMargin">{t("Newsfeed.No more data available")}</p >
      ) : (
        ''
      )}
      {
        nextBatchLoading && !loading && (
          <div className="text-center mb-4">
            <img src={post?.loader} width={50} />
          </div>
        )
      }


      {acceptNotification && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are You Sure You want to Accept")}</h6>

                <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleRemoveCertificateClose();
                  }}
                >
                  {t("User Profile.Close")}

                </span>
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="mainBtn1"
                  onClick={() => {
                    AcceptJob();
                    handleRemoveCertificateClose();
                  }}
                >
                  {t("Connections.Accept")}

                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEducationDelete && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are You Sure You want to Reject")}</h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleRemoveEducationClose();
                  }}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleRemoveEducationClose();
                  }} />
              </div>

              <div className="mt-2 text-center">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => {
                    RejectJob();
                    handleRemoveEducationClose();
                  }}
                >
                  {t("Connections.Reject")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isRemoveJobOfferModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are You Sure You want to Remove this job offer")}</h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setIsRemoveJobOfferModal(false);
                  }}
                >
                  </span> */}

                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setIsRemoveJobOfferModal(false);
                  }} />
              </div>

              <div className="mt-2 text-center">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => {
                    handleRemoveOfferedJobs();
                    setIsRemoveJobOfferModal(false)
                  }}
                >
                  {t("Connections.Remove")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {scheduleModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("Job Application.Add Interview Schedule Details")}</h6>
                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => handleScheduleModal()}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleScheduleModal();
                  }}
                />
              </div>
              {/* <div className="d-flex modalBorder pb-4 d-flex justify-content-center"> */}
              <div className="row settings mt-2  mb-2 userInput d-flex flex-column align-items-center px-4">
                <div className="col-md-12 mt-2">
                  <label htmlFor="remark">
                    {t("Job Application.Schedule Time")}<span style={{ color: "red" }}>*</span>
                  </label>

                  <Flatpickr
                    className="form-control"
                    value={startDate}
                    onChange={(date) => setStartDate(date[0])}
                    id="dob"
                    options={{
                      minDate: "today",
                      enableTime: true, // Enables time selection
                      time_24hr: true, // Enables 24-hour time format, if needed
                      dateFormat: "Y-m-d H:i", // Format: Year-Month-Day Hour:Minute
                      minuteIncrement: 1,
                      onReady: (selectedDates, dateStr, instance) => {
                        preventYearScroll(instance); // Call the function to stop scroll on year
                      },
                      onOpen: (selectedDates, dateStr, instance) => {
                        preventYearScroll(instance); // Also prevent scroll when the picker opens
                      },
                    }}
                  />
                </div>
                <div className="col-md-12 mt-2">
                  <label htmlFor="remark">
                    {t("Job Application.Place Type")} <span style={{ color: "red" }}>*</span>
                  </label>
                  <ReactSelect
                    name="country"
                    onChange={(e) => {
                      setInterviewPT(e?.label);
                    }}
                    defaultValue={interviewPT}
                    className="react-select dropdown-Input-react w-100"
                    classNamePrefix="select"
                    options={InterviewPlaceType}
                    isClearable={true}
                  />
                </div>
                <div className="col-md-12 mt-2">
                  <label htmlFor="remark">{t("Job Application.Place Details")}</label>
                  <input
                    type="text"
                    style={{ width: "100%" }}
                    value={placeDetail}
                    onChange={(e) => setPlaceDetail(e.target.value)}
                    className="form-control"
                  />
                </div>
                <div className="col-md-12 mt-2">
                  <label htmlFor="about">{t("Job Application.Remark")}</label>
                  <textarea
                    id="about"
                    name="about"
                    rows="2"
                    cols="65"
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  ></textarea>
                </div>
              </div>
              {/* </div> */}
              <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                <button
                  type="button"
                  className="mainBtn1 me-4"
                  onClick={handleSubmitSechdule}
                >
                  {t("User Profile.Submit")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default JobNotification;
